import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { isUndefined } from 'util';
import { LoginAndUserManagerService } from '../../../api/managers/login-and-user-manager.service';
import { LoggingService } from '../../../services/logging.service';

@Component({
    selector: 'app-confirm-registration',
    templateUrl: './confirm-registration.component.html',
    styleUrls: ['./confirm-registration.component.less']
})
export class ConfirmRegistrationComponent implements OnInit {
    successMessage = '';
    failureMessage = '';

    id;
    secret;
    validationEmail;
    error;

    isLoading = false;

    constructor(private router: Router, private loginAndUserManagerService: LoginAndUserManagerService) { }

    ngOnInit() {
        this.id = (this.router.parseUrl(this.router.url)).queryParams.id;
        this.secret = encodeURIComponent((this.router.parseUrl(this.router.url)).queryParams.secret);
        this.secret = String(this.secret.replace('%', '')).toLowerCase();
        if (isUndefined(this.id) || isUndefined(this.secret)) {
            this.router.navigateByUrl('welcome');
        }
    }

    goToLogin() {
        this.router.navigateByUrl('/welcome?signIn=true');
    }

    onValidateUser() {
        this.isLoading = true;
        this.loginAndUserManagerService.validateUser(this.id, this.secret)
            .subscribe(user => {
                this.isLoading = false;
                this.successMessage = user['Email'] + ' has been verified. Redirecting...';
                setTimeout((router: Router) => {
                    this.router.navigate(['/welcome'], { queryParams: { signIn: true } });
                }, 5000);
            }, err => {
                this.isLoading = false;
                LoggingService.log(err);
                this.failureMessage = err.error.ModelState.Error;
            });
    }

    resendValidationEmail(form: NgForm) {
        this.loginAndUserManagerService.sendConfirmationEmail(form.value.validationEmail).subscribe(user => {
            this.router.navigate(['register/success'], { queryParams: { email: form.value.validationEmail } });
        }, err => {
            this.router.navigate(['register/resend'], { queryParams: { email: form.value.validationEmail } });
        });
    }

}
